import { MaterialCompletionStatus, Unit, UnitState } from "./types";


export const parseRoadMapItems = (items: any[]): Unit[] => {
  return items.map((item, index) => {
    const hasNext = items.length > index + 1;
    const hasPrevious = index > 0;
    const previousStatus: MaterialCompletionStatus = index > 0 ? items[index - 1]?.content_material?.completion_status : null;

    let state: UnitState;
    if (item.content_material.completion_status === 'completed') {
      state = 'done';
    } else if (!hasPrevious || previousStatus === 'completed') {
      state = 'unlocked';
    } else {
      state = 'locked'
    }

    return {
      ...item,
      state,
    }
  })
}